var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

/**
 * Gets and returns a list of FIND clients
 */
export default function getClientList(sDispatch) {

    const abortController = new AbortController();

      let mounted = true;
      (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/find/client/list', {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {

          if (data.status === "success"){
            sDispatch({
              type: "setClientList",
              payload: { clientList: data.clients }
            });
          } else {
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
    })();
}